<template>
  <a-steps direction="vertical" :current="form.data.length-1">
    <a-step
        v-for="item in form.data"
        :key="item.ftime"
        :title="moment(item.ftime).format('YYYY-MM-DD HH:mm:ss')"
        :description="item.context"/>
  </a-steps>
</template>

<script>

import moment from 'moment';

async function getOrderExpressInfo() {
  this.form.data = this.goodsOrderTrackData.reverse();
}

export default {
  name: 'WebsiteOrderExpressTrack',
  props: {
    goodsOrderExpressId: String,
    goodsOrderTrackData: Map,
  },
  methods: {
    getOrderExpressInfo,
  },
  data() {
    return {
      moment: moment,
      form: {
        data: [],
      }
    };
  },
  created() {
    if (this.goodsOrderExpressId) {
      this.getOrderExpressInfo();
    }
  }
};
</script>

<style>

</style>
